export default __webpack_public_path__ + "static/media/close.ffdafe3f.png";